import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import withStyles from 'isomorphic-style-loader/withStyles';
import { Field, change, formValueSelector } from 'redux-form';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import { Button, FormGroup, FormControl, InputGroup } from 'react-bootstrap';
import cx from 'classnames';

import PhoneVerificationModal from "../PhoneVerificationModal/PhoneVerificationModal";
import CountryList from "../CountryList/CountryList";

import PopulateData from "../../helpers/populateData";
import ProfileUpload from "../../helpers/EditProfileInfo/profileUpload";
import ToolTipSection from "../Common/ToolTipSection/ToolTipSection";

import cs from '../../components/commonStyle.css';
import s from './CommonFields.css';
import messages from '../../locale/jsonMessages';

class CommonFields extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dateOfBirthData: {},
            countryCode: 'US',
            country: '+1',
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
    }
    UNSAFE_componentWillMount() {
        let now = new Date();
        let currentYear = now.getFullYear();
        let years = PopulateData.generateData(1900, currentYear, "desc");
        let days = PopulateData.generateData(1, 31);
        let months = PopulateData.generateData(0, 11);
        this.setState({
            dateOfBirthData: {
                years: years,
                months: months,
                days: days
            }
        });
    }
    componentDidMount() {
        const { initialValues } = this.props;
        const { country, countryCode } = this.state;
        if (initialValues && initialValues?.countryCode) {
            this.setState({
                countryCode: initialValues?.countryName ? initialValues?.countryName : countryCode,
                country: initialValues?.countryCode ? initialValues?.countryCode : country
            });
        }
    }


    renderFormControl = ({ input, label, type, meta: { touched, error }, className, maxLength, isDisabled, inputPaddingClass, infoText, showToolTip, isRequiredInput }) => {
        const { formatMessage } = this.props.intl;
        return (
            <FormGroup className={cx(cs.noMargin, inputPaddingClass)}>
                <label className='commonLabelText'>
                    {label}{isRequiredInput && <sup className='isRequiredStar'>*</sup>}
                    {showToolTip && <ToolTipSection label={infoText} />}
                </label>
                <FormControl {...input} placeholder={label} type={type} className={className} disabled={isDisabled} maxLength={maxLength} />
                {touched && error && <span className={cs.errorMessage}>{formatMessage(error)}</span>}
            </FormGroup>
        )
    }
    renderFormControlSelect = ({ input, meta: { touched, error }, children, className, inputPaddingClass, options }) => {
        const { formatMessage } = this.props.intl;
        return (
            <FormGroup className={cx(cs.noMargin, inputPaddingClass)}>
                <FormControl componentClass="select" {...input} className={cx(className)}>
                    {options?.map((item, key) => {
                        return (
                            <option key={key} value={item?.value}>
                                {item?.label}
                            </option>
                        );
                    })}
                </FormControl>
                {touched && error && <span className={cs.errorMessage}>{formatMessage(error)}</span>}
            </FormGroup>
        )
    }
    renderFormControlEmail = ({ input, label, type, meta: { touched, error }, className, disabled, inputPaddingClass }) => {
        const { formatMessage } = this.props.intl;
        return (
            <FormGroup className={cx(cs.noMargin, inputPaddingClass)}>
                <label className="commonLabelText">{label}</label>
                <FormControl {...input} placeholder={label} type={type} className={className} disabled={disabled} />
                {touched && error && <span className={cs.errorMessage}>{formatMessage(error)}</span>}
            </FormGroup>
        )
    }

    renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }, isRequiredInput) => {
        const { formatMessage } = this.props.intl;

        return (
            <FormGroup className={cs.noMargin}>
                <label className="commonLabelText">{label}{isRequiredInput && <sup className='isRequiredStar'>*</sup>}</label>
                <FormControl
                    {...input}
                    className={className}
                    componentClass="textarea"
                    rows={5}
                    placeholder={label}
                >
                    {children}
                </FormControl>
                {touched && error && <span className={cs.errorMessage}>{formatMessage(error)}</span>}
            </FormGroup>
        )
    }
    renderFormControlCurrency = ({ input, label, type, meta: { touched, error }, className, country, maxLength }) => {
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <InputGroup>
                    <InputGroup.Addon >
                        {country}
                    </InputGroup.Addon>
                    <FormControl {...input} placeholder={label} type={type} className={className} maxLength={maxLength} />
                </InputGroup>
                {touched && error && <span className={cs.errorMessage}>{formatMessage(error)}</span>}
            </div>
        )
    }
    handleChange(event) {
        const { change } = this.props;
        this.setState({ [event.target.name]: event.target.value });
        change('EditProfileForm', event.target.name, event.target.value)
    }

    handleCountryChange(e, selectedData) {

        this.setState({
            country: selectedData.dialCode,
            countryCode: selectedData.countryCode
        });
        change('EditProfileForm', 'phoneCountryCode', selectedData.countryCode)
        change('EditProfileForm', 'dialCode', selectedData.dialCode)

    }

    render() {
        const { formatMessage } = this.props.intl;
        const { dateOfBirthData, countryCode, country } = this.state;
        const { siteSettingStatus, isAdmin, picture, initialValues } = this.props;
        let isPhoneStatus, genderValue, monthValue, daysValue, yearsValue;
        isPhoneStatus = siteSettingStatus && siteSettingStatus.phoneNumberStatus == 3 ? false : true;

        genderValue = [
            { value: '', label: formatMessage(messages.gender) },
            { value: "Male", label: formatMessage(messages.genderMale) },
            { value: "Female", label: formatMessage(messages.genderFemale) },
            { value: 'Other', label: formatMessage(messages.genderOther) }
        ]

        monthValue = [
            { value: '', label: formatMessage(messages.month) },
        ];

        daysValue = [
            { value: '', label: formatMessage(messages.transferDate) },
        ];

        yearsValue = [
            { value: '', label: formatMessage(messages.year) },
        ];


        dateOfBirthData?.months?.length > 0 && dateOfBirthData?.months?.map((item, key) => {
            monthValue.push({
                value: item,
                label: item + 1
            })
        })

        dateOfBirthData?.days?.length > 0 && dateOfBirthData?.days?.map((item, key) => {
            daysValue.push({
                value: item,
                label: item
            })
        })

        dateOfBirthData?.years?.length > 0 && dateOfBirthData?.years?.map((item, key) => {
            yearsValue.push({
                value: item,
                label: item
            })
        });

        return (
            <div>
                {
                    isAdmin && <div className={s.userAvatarSection}>
                        <ProfileUpload
                            picture={picture}
                            userId={initialValues?.userId}
                            isAdmin={isAdmin}
                        />
                    </div>
                }
                <div className="oneColumnGrid">
                    <div className='twoColumnGrid'>
                        <Field name="firstName"
                            type="text"
                            component={this.renderFormControl}
                            label={formatMessage(messages.firstName)}
                            placeholder={formatMessage(messages.firstName)}
                            className='commonInputField'
                            infoText={formatMessage(messages.lastNameInfo)}
                            showToolTip
                            isRequiredInput
                        />
                        <Field name="lastName"
                            type="text"
                            component={this.renderFormControl}
                            label={formatMessage(messages.lastName)}
                            placeholder={formatMessage(messages.lastName)}
                            className='commonInputField'
                            isRequiredInput
                        />
                    </div>
                    <div className='twoColumnGrid'>
                        <div>
                            <label className="commonLabelText">{formatMessage(messages.genderLabel)}</label>
                            <Field
                                name="gender"
                                label={formatMessage(messages.gender)}
                                component={this.renderFormControlSelect}
                                options={genderValue}
                                className='commonSelectField'
                            />
                        </div>
                        <div>
                            <label className="commonLabelText">{formatMessage(messages.dateOfBirth)}</label><sup className='isRequiredStar'>*</sup>
                            <div className={s.dateGridSection}>
                                <Field
                                    name="month"
                                    className='commonSelectField'
                                    component={this.renderFormControlSelect}
                                    options={monthValue}
                                />
                                <Field
                                    name="day"
                                    className='commonSelectField'
                                    component={this.renderFormControlSelect}
                                    options={daysValue}
                                />
                                <Field
                                    name="year"
                                    className='commonSelectField'
                                    component={this.renderFormControlSelect}
                                    options={yearsValue}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='twoColumnGrid'>
                        <Field name="email"
                            type="text"
                            component={this.renderFormControlEmail}
                            label={formatMessage(messages.emailLabel)}
                            className={'commonInputField'}
                            disabled
                        />
                        <Field name="location"
                            type="text"
                            component={this.renderFormControl}
                            label={formatMessage(messages.location)}
                            className='commonInputField'
                            placeholder={formatMessage(messages.location)}
                            maxLength={255}
                            isRequiredInput
                        />
                    </div>
                    <div>
                        <label className="commonLabelText">{formatMessage(messages.phoneNumber)}{<sup className='isRequiredStar'>*</sup>}</label>
                        {
                            isAdmin ?
                                <div className={cx(cs.commonBorderSection, 'whiteBgColor', 'oneColumnGrid')}>
                                    <div>
                                        <label className="commonLabelText"><FormattedMessage  {...messages.chooseACountry} /></label>
                                        <CountryList
                                            input={
                                                {
                                                    name: 'countryCode',
                                                    onChange: this.handleChange,
                                                    value: countryCode,
                                                }
                                            }
                                            className='commonSelectField'
                                            dialCode={false}
                                            getSelected={this.handleCountryChange}
                                            formName={'EditProfileInfo'}
                                        />
                                    </div>
                                    <div>
                                        <label className="commonLabelText"><FormattedMessage  {...messages.addAPhoneNumber} /></label>
                                        <Field
                                            name="phoneNumber"
                                            type="text"
                                            component={this.renderFormControlCurrency}
                                            maxLength={255}
                                            label={formatMessage(messages.enterPhoneNumber)}
                                            className='commonInputField'
                                            onChange={this.handleChange}
                                            country={country}
                                            isRequiredInput
                                        />
                                    </div>
                                </div> :
                                <>
                                    {!isPhoneStatus &&
                                        <div className={cx(cs.commonBorderSection, 'whiteBgColor', 'oneColumnGrid')}>
                                            <div>
                                                <label className="commonLabelText"><FormattedMessage  {...messages.chooseACountry} /></label>
                                                <CountryList
                                                    input={
                                                        {
                                                            name: 'countryCode',
                                                            onChange: this.handleChange,
                                                            value: countryCode,
                                                        }
                                                    }
                                                    className='commonSelectField'
                                                    dialCode={false}
                                                    getSelected={this.handleCountryChange}
                                                    formName={'EditProfileForm'}
                                                />
                                            </div>
                                            <div>
                                                <label className="commonLabelText"><FormattedMessage  {...messages.addAPhoneNumber} /></label>
                                                <Field
                                                    name="phoneNumber"
                                                    type="text"
                                                    component={this.renderFormControlCurrency}
                                                    maxLength={255}
                                                    label={formatMessage(messages.enterPhoneNumber)}
                                                    className='commonInputField'
                                                    onChange={this.handleChange}
                                                    country={country}
                                                />
                                            </div>
                                        </div>}
                                    {isPhoneStatus && <PhoneVerificationModal />}
                                    <p className={cs.commonMediumText}>{formatMessage(messages.phoneNumberInfo)}</p>
                                </>
                        }
                    </div>
                    <Field name="info"
                        component={this.renderFormControlTextArea}
                        label={formatMessage(messages.info)}
                        className='commonTextAreaField'
                        isRequiredInput
                    />
                </div>
                <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
                    <Button className={cx(cs.btnPrimary, cs.btnMedium)} type="submit" >
                        {formatMessage(messages.save)}
                    </Button>
                </div>
            </div>
        )
    }
}
const selector = formValueSelector('EditProfileInfo');

const mapState = (state) => ({
    siteSettingStatus: state?.siteSettings?.data,
    isAdmin: state?.runtime?.isAdminAuthenticated,
    picture: selector(state, 'picture')
});
const mapDispatch = {
    change
};

export default compose(injectIntl, withStyles(cs, s), connect(mapState, mapDispatch))(CommonFields);
